import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Row } from '@cuemath/comps';

const Wrapper = styled(Row)`
  gap: 40px;
`;

const TableWrapper = styled.div`
  width: fit-content;
  overflow-x: auto;
`;

const speedTableColumns = [
  {
    columns: [
      {
        Header: 'Type',
        accessor: 'type',
        width: 200,
      },
      {
        Header: 'Expected',
        accessor: 'expected',
        width: 100,
      },
      {
        Header: 'Average',
        accessor: 'average',
        width: 100,
      },
      {
        Header: 'Median',
        accessor: 'median',
        width: 100,
      },
    ],
  },
];

const chapterTableColumns = [
  {
    columns: [
      {
        Header: 'Type',
        accessor: 'type',
        width: 300,
      },
      {
        Header: 'Average',
        accessor: 'average',
        width: 100,
      },
      {
        Header: 'Median',
        accessor: 'median',
        width: 100,
      },
    ],
  },
];

class SpeedStatTable extends PureComponent {
  render() {
    const { speedStatData, chapterStatData } = this.props;

    return (
      <Wrapper>
        <TableWrapper>
          <ReactTable
            data={speedStatData}
            className="-striped -highlight"
            manual
            filterable={false}
            sortable={false}
            defaultPageSize={3}
            resizable={false}
            columns={speedTableColumns}
            style={{ textAlign: 'center' }}
          />
        </TableWrapper>
        <TableWrapper>
          <ReactTable
            data={chapterStatData}
            className="-striped -highlight"
            manual
            filterable={false}
            sortable={false}
            defaultPageSize={3}
            resizable={false}
            columns={chapterTableColumns}
            style={{ textAlign: 'center' }}
          />
        </TableWrapper>
      </Wrapper>
    );
  }
}

SpeedStatTable.propTypes = {
  chapterStatData: PropTypes.arrayOf(PropTypes.shape({})),
  speedStatData: PropTypes.arrayOf(PropTypes.shape({})),
};

SpeedStatTable.defaultProps = {
  chaptersData: null,
  speedStatData: null,
};

export default SpeedStatTable;
